import { TypedRootState } from '../types';

export const selectSliceType = (state: TypedRootState) => state.sliceType;
